import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import VehicleHiringEntryForm from "./VehicleHiringEntryComponents/VehicleHiringEntryForm";
import {
  useGetVehicleHiringEntryDetailQuery,
  useUpdateVehicleHiringEntryMutation,
} from "store/services/vehicleHiringEntryApi";

const VehicleHiringEntryEditScreen = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const breadcrumbs = [
    { title: "Vehicle Hiring Entry", path: "/app/crm/vehicle-hiring-entry/list" },
    { title: "Edit Hiring Entry" },
  ];

  const {
    data: vehicleHiringEntryDetail,
    isLoading: loadingVehicleHiringEntry,
    error,
  } = useGetVehicleHiringEntryDetailQuery(id);

  const [updateVehicleHiringEntry, { isLoading: isUpdating }] =
    useUpdateVehicleHiringEntryMutation();

  const handleUpdate = async (data) => {
    try {
      await updateVehicleHiringEntry({ id, ...data }).unwrap();
      toast.success("Vehicle Hiring Entry successfully updated!");
      navigate(`/app/crm/vehicle-hiring-entry/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update Entry!"
      );
    }
  };

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingVehicleHiringEntry}
    >
      <BreadcrumbLayout.Error error={error} />
      <BreadcrumbLayout.Paper>
        <VehicleHiringEntryForm
          isBusy={loadingVehicleHiringEntry || isUpdating}
          entryDetail={vehicleHiringEntryDetail}
          onSubmit={handleUpdate}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default VehicleHiringEntryEditScreen;